import React from 'react';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import { StyledButtonWrapper } from './styles';

const DS_BookAppointmentButton = ({
  label,
  fixWidth = false,
  url,
  isBookingFunnel = false,
  onLocationSelection,
  isBigButton = false,
}) => {
  return (
    <>
      {isBookingFunnel ? (
        <StyledButtonWrapper className={fixWidth && 'fix-width'}>
          <DS_ButtonLink
            title={label || 'Choose Appointment'}
            onClick={onLocationSelection}
            buttonSize={isBigButton}
            id="booking-funnel-choose-location-btn"
          ></DS_ButtonLink>
        </StyledButtonWrapper>
      ) : url ? (
        <StyledButtonWrapper className={fixWidth && 'fix-width'}>
          <DS_ButtonLink
            title={label || 'Choose Appointment'}
            url={url}
            target="_self"
            buttonSize={isBigButton}
            external={true}
          ></DS_ButtonLink>
        </StyledButtonWrapper>
      ) : null}
    </>
  );
};

export default DS_BookAppointmentButton;
